<template>
  <el-button
    ref="button"
    :type="type"
    :size="size"
    :plain="plain"
    :round="round"
    :circle="circle"
    :loading="loading"
    :disabled="disabled"
    :icon="icon"
    @click="onClick"
    @keydown.enter.capture.native="onEnterKey($event)"
  >{{buttonText}}</el-button>
</template>

<script>
/* eslint-disable semi */
import { Component, Prop } from 'vue-property-decorator';
import AppComponent from '@/app/AppComponent';

@Component({})
export default class AppButton extends AppComponent {
  @Prop({ type: String, required: false, default: '' })
  type;
  @Prop({ type: String, required: false, default: '' })
  size;
  @Prop({ type: Boolean, required: false, default: false })
  plain;
  @Prop({ type: Boolean, required: false, default: false })
  round;
  @Prop({ type: Boolean, required: false, default: false })
  circle;
  @Prop({ type: Boolean, required: false, default: false })
  loading;
  @Prop({ type: Boolean, required: false, default: false })
  disabled;
  @Prop({ type: String, required: false, default: '' })
  icon;
  @Prop({ type: String, required: false, default: '' })
  label;

  data () {
    return {
      buttonText: null
    };
  }

  created () {
    this.buttonText = this.label;
  }

  onClick () {
    this.$emit('click');
  }

  // エンターキーイベント
  onEnterKey (event) {
    this.$emit('app-event', 'enterkey', event, this);
  }

  focus () {
    this.$refs.button.$el.focus();
  }
}
</script>



// WEBPACK FOOTER //
// src/app/parts/button/AppButton.vue